import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiButton, EuiButtonIcon, EuiToolTip } from '@elastic/eui'

import { MasterCampaignPlan, MasterCampaignPlanStatus } from 'api/interfaces/MasterCampaignPlan'
import { RootState } from 'app/rootReducer'
import { selectMultiTabPdfGenerationState } from 'features/planner/pages/MasterCampaignPlanPage/pdfViewSlice'

export interface TabPageHeaderProps {
  title: string
  inEditMode?: boolean
  onClientPdfClick?: () => void
  onAllClientPdfsClick?: () => void
  onAllStaffPdfsClick?: () => void
  staffPdfDisabledReason?: string
  onEditClick?: () => void
  isEditingPlan?: boolean
  showBackButton?: boolean
  onBackClick?: () => void
  isGeneratingPdf?: boolean
  hideAllPdfsButton?: boolean
  onEditPageTitle?: () => void
  usePencilIconForEdit?: boolean
}

const TabPageHeader: FC<TabPageHeaderProps> = ({ title, inEditMode, onClientPdfClick, onAllClientPdfsClick, onAllStaffPdfsClick, staffPdfDisabledReason, onEditClick, isEditingPlan, showBackButton, onBackClick, isGeneratingPdf, hideAllPdfsButton, onEditPageTitle, usePencilIconForEdit }) => {
  const { masterCampaignPlanId } = useParams<{ masterCampaignPlanId: string }>()
  const { isStaffUser, showInternalView } = useSelector((state: RootState) => state.app)
  const { isStaffPdf, isGenerating: isGeneratingAllPdfs } = useSelector((state: RootState) => selectMultiTabPdfGenerationState(state, masterCampaignPlanId))

  return (
    <>
      <EuiFlexGroup justifyContent='spaceBetween'>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiTitle size='m'>
                <h3>{title}</h3>
              </EuiTitle>
            </EuiFlexItem>
            {usePencilIconForEdit && !inEditMode && onEditClick && (
              <EuiFlexItem grow={false}>
                <EuiButtonIcon iconType='pencil' onClick={onEditClick} aria-label='Edit' />
              </EuiFlexItem>
            )}
            {onEditPageTitle && (
              <EuiFlexItem grow={false}>
                <EuiButtonIcon iconType='visText' style={{ color: '#0071c2' }} onClick={onEditPageTitle} aria-label='Edit title' size='s' />
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup>
            {showBackButton && onBackClick && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' onClick={onBackClick}>
                  Exit Client PDF
                </EuiButton>
              </EuiFlexItem>
            )}
            {isStaffUser && showInternalView && !inEditMode && onAllStaffPdfsClick && !hideAllPdfsButton && (
              <EuiFlexItem grow={false}>
                {staffPdfDisabledReason ? (
                  <EuiToolTip content={staffPdfDisabledReason}>
                    <EuiButton size='s' color='primary' disabled>
                      All Staff PDFs
                    </EuiButton>
                  </EuiToolTip>
                ) : (
                  <EuiButton size='s' color='primary' onClick={onAllStaffPdfsClick} isLoading={isStaffPdf && isGeneratingAllPdfs} disabled={isGeneratingAllPdfs || isGeneratingPdf}>
                    All Staff PDFs
                  </EuiButton>
                )}
              </EuiFlexItem>
            )}
            {false && !inEditMode && onAllClientPdfsClick && !hideAllPdfsButton && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' color='primary' onClick={onAllClientPdfsClick} isLoading={!isStaffPdf && isGeneratingAllPdfs} disabled={isGeneratingAllPdfs || isGeneratingPdf}>
                  All Client PDFs
                </EuiButton>
              </EuiFlexItem>
            )}
            {!inEditMode && onClientPdfClick && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' color='primary' onClick={onClientPdfClick} isLoading={isGeneratingPdf} disabled={isGeneratingPdf || isGeneratingAllPdfs}>
                  Client PDF
                </EuiButton>
              </EuiFlexItem>
            )}
            {!usePencilIconForEdit && !inEditMode && onEditClick && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' onClick={onEditClick} isLoading={isEditingPlan} fill>
                  Edit
                </EuiButton>
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiHorizontalRule />
    </>
  )
}

export default TabPageHeader
